import React from 'react'
import { Tooltip } from '@progress/kendo-react-tooltip'

import INFO_WARNING from '@public/assets/warning_triangle_yellow.svg'
import {
  isNetDocumentsNoiseItem,
  NETDOCUMENTS_NOISE_HINT,
} from './timeNoiseUtils'

interface NetDocumentsNoiseDurationHintProps {
  item?: unknown
  style?: React.CSSProperties
}

export function NetDocumentsNoiseDurationHint({
  item,
  style,
}: NetDocumentsNoiseDurationHintProps) {
  if (!isNetDocumentsNoiseItem(item)) return null

  return (
    <Tooltip
      parentTitle
      anchorElement="target"
      position="left"
      tooltipStyle={{
        maxWidth: '320px',
        border: 'none',
        backgroundColor: '#000',
        color: '#fff',
        padding: '4px 8px',
        fontSize: '14px',
        fontWeight: 400,
      }}
    >
      <span
        title={NETDOCUMENTS_NOISE_HINT}
        style={{
          marginLeft: 4,
          display: 'inline-flex',
          alignItems: 'center',
          flexShrink: 0,
          alignSelf: 'center',
          ...style,
        }}
      >
        <img
          src={INFO_WARNING}
          alt="warning"
          style={{ display: 'flex', width: 14, height: 14 }}
        />
      </span>
    </Tooltip>
  )
}
